/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Deactivate_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "All connector syncs will stop. Files and embeddings are preserved. Members lose access until you reactivate." |
*
* @param {Spaces_Deactivate_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_deactivate_confirm_description = /** @type {((inputs?: Spaces_Deactivate_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Deactivate_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Connector-Syncs werden gestoppt. Dateien und Embeddings bleiben erhalten. Mitglieder verlieren den Zugriff bis zur Reaktivierung.")
	return /** @type {LocalizedString} */ ("All connector syncs will stop. Files and embeddings are preserved. Members lose access until you reactivate.")
});